module.exports = __webpack_public_path__ + "static/media/button.98e642f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/button.svg
// module id = 1050
// module chunks = 3